import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4cd8b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-profile" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "sqg-profile__board" }
const _hoisted_4 = { class: "sqg-profile__line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-at" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase" }, null, -1))
const _hoisted_8 = { class: "sqg-profile__line" }

import {onMounted, ref} from "vue";
import {useUserStore} from "@/stores/user";
import {useRouter} from 'vue-router';
import {storeToRefs} from "pinia";
import {randomColor} from '@/functions/utils';
import api from "@/api/spaceMountainAPI";
import CardButton from '@/components/CardButton.vue';
import Card from '@/components/Card.vue';
import Header from '@/components/Header.vue';
import Loader from '@/components/Loader.vue';
import ChangePassword from '@/modales/ChangePassword.vue';
import ChangeUserInfos from '@/modales/ChangeUserInfos.vue';
import ChangeAvatar from '@/modales/ChangeAvatar.vue';

//STORE user

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

//DATA
const loaderUserInfo = ref(true);
const loaderUserInfoErrorMsg = ref('');
const isChangePasswordOpen = ref(false);
const isChangeUserInfosOpen = ref(false);
const isChangeAvatarOpen = ref(false);

const refreshPage = () => {
  isChangeUserInfosOpen.value = false;
  loadProfile();
}

const changeAvatar = ($event: any) => {
  console.log($event);
}

const loadProfile = () => {
  userStore.loadUserInfo().then((response) => {
    if (response.status === 200) {
      loaderUserInfo.value = false;
    } else loaderUserInfoErrorMsg.value = response.error;
  });
}

onMounted(() => {
  loadProfile();
});

const router = useRouter();
const logout = () => {
  router.push('/login');
}

const resetPref = () => {
  api.resetPreferences().then(() => refreshPage());
}

const isHover = ref(false);

const { user } = storeToRefs(userStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, {
        icone: "fas fa-user",
        title: "Votre profil",
        displayCurrentFolder: false
      }),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "sqg-profile__avatar",
            style: _normalizeStyle(`background-color: ${_unref(randomColor)(_unref(user).id)}`)
          }, [
            (!isHover.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(user).firstname[0]) + _toDisplayString(_unref(user).lastname[0]), 1))
              : _createCommentVNode("", true)
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Card, {
              width: "100",
              height: "240px",
              class: "sqg-profile__secondaryInfos"
            }, {
              default: _withCtx(() => [
                (loaderUserInfo.value)
                  ? (_openBlock(), _createBlock(Loader, {
                      key: 0,
                      errorMsg: loaderUserInfoErrorMsg.value
                    }, null, 8, ["errorMsg"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", null, [
                        _hoisted_5,
                        _createTextVNode(_toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_6,
                        _createTextVNode(" " + _toDisplayString(_unref(user).email), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_unref(user).companyName), 1)
                      ])
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
              ? (_openBlock(), _createBlock(CardButton, {
                  key: 0,
                  icon: "fas fa-edit",
                  text: "Modifier mon profile",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isChangeUserInfosOpen.value = true))
                }))
              : _createCommentVNode("", true),
            _createVNode(CardButton, {
              icon: "fas fa-key",
              text: "Changer le mot de passe",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isChangePasswordOpen.value = true))
            }),
            _createVNode(CardButton, {
              icon: "fas fa-sign-out-alt",
              text: "Déconnexion",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
            }),
            _createVNode(CardButton, {
              icon: "fa-solid fa-shower",
              text: "Réinitialiser les préférences (only for developers)",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (resetPref()))
            })
          ])
        ])
      ])
    ]),
    _createVNode(ChangePassword, {
      isOpen: isChangePasswordOpen.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isChangePasswordOpen.value = false)),
      onChangePassword: _cache[5] || (_cache[5] = ($event: any) => (isChangePasswordOpen.value = false))
    }, null, 8, ["isOpen"]),
    _createVNode(ChangeUserInfos, {
      isOpen: isChangeUserInfosOpen.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (isChangeUserInfosOpen.value = false)),
      onChangeUserinfos: refreshPage
    }, null, 8, ["isOpen"])
  ], 64))
}
}

})